import { createAxiosInstance } from '@/api/http'
import env from '@/config/env'
import { Headers } from '@/utilities/constants'
import { type GetApplicationConfigParams, type ApplicationConfigData } from '@/types/config'

const http = createAxiosInstance(
  {
    baseURL: env.apiBaseUrl
  },
  [Headers.TenantUUID],
  {
    withBasicAuth: true
  }
)

const getApplicationSettings = async (
  params: GetApplicationConfigParams
): Promise<ApplicationConfigData> => {
  const url = `api/v1/terminal/config/${params.dongleId}`

  const { data } = await http.get(url)
  return data
}

export default { getApplicationSettings }
